var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "订单操作记录",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.dialogClose } },
                [_vm._v("关　闭")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-table",
        {
          attrs: {
            stripe: "",
            fit: "",
            "highlight-current-row": "",
            data: _vm.list,
            "header-cell-class-name": "table-header-cell",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              width: "60",
              align: "center",
              type: "index",
              "class-name": "table-header-cell",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作时间", prop: "createTime", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { label: "备注说明", prop: "remark" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }